export default __webpack_public_path__ + "static/media/e-nstitute-large.b9eaa5c1.png";